import EdInputTable from './src/EdInputTable.vue';

/* istanbul ignore next */
EdInputTable.install = function (Vue) {
  Vue.component(EdInputTable.name, EdInputTable)
}

export default EdInputTable;
